<template>
    <div class="layout-mobile-sidebar-user">
        <div v-if="!isLogin" class="user-avatar"
             @click="handleLogin"
        >
            <a-avatar class="avatar" :size="32" icon="user" />
            <span>登录/注册</span>
        </div>
        <div v-else class="user-avatar">
            <div>
                <a-avatar class="avatar" :size="32" :src=userInfo.avatarUrl icon="user" />
                <span class="nickname">{{userInfo.nickname}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "../../../mixin/common";
    import {createNamespacedHelpers} from "vuex";

    const {mapState} = createNamespacedHelpers('login');


    export default {
        name: "LayoutSidebarUser",
        mixins: [common],

        methods: {
            handleLogin() {
                this.changeShowSidebar(false);
                this._changeLoginModal(true)
            }
        },
        computed: {

            ...mapState({
                isLogin: 'isLogin',
                userInfo: "userInfo"
            })
        }
    }
</script>

<style scoped lang="less">
    .layout-mobile-sidebar-user {
        height: 60px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-content: center;
        border-bottom: 1px solid #f2f2f2
    }

    .user-avatar {
        display: flex;
        justify-content: space-around;
        align-content: center;
        align-items: center;

        span {
            margin: 0 3px;
        }
    }

    .nickname {
        margin-right: 8px;
        width: 84px;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle
    }
</style>
